<template>
  <div class="code-input">
    <input
      v-for="(digit, index) in code"
      :key="index"
      ref="inputs"
      v-model="code[index]"
      type="text"
      maxlength="1"
      inputmode="numeric"
      pattern="\d*"
      class="code-box"
      placeholder="_"
      @input="onInput(index)"
      @keydown.backspace="onBackspace(index)"
      @paste="onPaste($event)"
    />
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
const leng = 7
const emit = defineEmits(['code-input', 'code-input-end'])

const code = ref(Array.from({ length: leng }, () => ''))
const inputs = ref([])

const onInput = (index) => {
  emit('code-input', code.value.join(''))
  if (code.value.join('').length === leng) {
    emit('code-input-end', code.value.join(''))
  }
  const input = inputs.value[index]
  if (input.value.length === 1 && index < leng - 1) {
    inputs.value[index + 1].focus()
  }
}

const onBackspace = (index) => {
  if (code.value[index] === '' && index > 0) {
    inputs.value[index - 1].focus()
  }
}

const onPaste = (event) => {
  event.preventDefault()
  const pasteData = (event.clipboardData || window.clipboardData).getData('text')
  const digits = pasteData.replace(/\D/g, '').slice(0, leng).split('')
  digits.forEach((char, index) => {
    if (index < leng) {
      code.value[index] = char
    }
  })
  // Устанавливаем фокус на следующее свободное поле
  const nextIndex = digits.length < leng ? digits.length : leng - 1
  inputs.value[nextIndex].focus()
}

onMounted(() => {
  inputs.value[0].focus()
})
</script>

<style scoped>
.code-input {
  display: flex;
  justify-content: space-between;
}

.code-box {
  width: 40px;
  height: 40px;
  font-size: 24px;
  text-align: center;
  border: 1px solid var(--base-color);
  border-radius: calc(var(--base-border-radius) - var(--base-padding));
}

.code-box::placeholder {
  color: var(--base-color);
  opacity: 0.5;
}
</style>
